import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'

import UserService from './services/user-service'

const app = createApp(App)
app.use(router)
app.use(store)
app.config.globalProperties.$checkPermission = (entry) => UserService.hasPermission(entry)

// Logo based on domain
const logoMap = {
  'platform.lamusica.com': '/media/logos/lamusica-logo.svg',
  'platform.streamcentral.io': '/media/logos/streamcentral-logo.svg'
}
const isStreamCentral = window.location.hostname.includes('streamcentral')
app.config.globalProperties.$logo = logoMap[window.location.hostname] || '/media/logos/lamusica-logo.svg'
app.config.globalProperties.$appName = isStreamCentral ? 'StreamCentral' : 'LaMusica'
app.config.globalProperties.$isStreamCentral = isStreamCentral
app.config.globalProperties.$playerEventsUrl = isStreamCentral ? '/sdk/api-docs-streamcentral.html' : '/sdk/api-docs.html'

// Media URL helper
const mediaBaseUrl = process.env.VUE_APP_MEDIA_URL || ''
const staticCDNBaseUrl = process.env.VUE_APP_STATIC_CDN_URL || ''
app.config.globalProperties.$mediaUrl = {
  media: (mediaId, format) => `${mediaBaseUrl}/media/${mediaId}/${format}`,
  slate: (slateId) => `${mediaBaseUrl}/slate/${slateId}`,
  live: (liveId, dvrSessionId = null) => `${mediaBaseUrl}/live/${liveId}${dvrSessionId ? `/dvr/${dvrSessionId}` : ''}`,
  recording: (recordingId) => `${mediaBaseUrl}/recording/${recordingId}`,
  thumbUrl: (relativePath) => relativePath ? `${staticCDNBaseUrl}/thumbs/${relativePath}` : ''
}

app.config.globalProperties.$filters = {
  formatDate(date) {
    if (!date) return '—'
    return new Date(date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
  },
  formatDatetime(date) {
    if (!date) return '—'
    return new Date(date).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
  },
  formatBytes(bytes) {
    if (!bytes) return '—'
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    let size = bytes, i = 0
    while (size >= 1024 && i < units.length - 1) { size /= 1024; i++ }
    return size.toFixed(i > 0 ? 1 : 0) + ' ' + units[i]
  },
  formatTime(date) {
    if (!date) return '—'
    const d = new Date(date)
    if (isNaN(d)) return '—'
    const h = d.getHours()
    const m = String(d.getMinutes()).padStart(2, '0')
    const ampm = h >= 12 ? 'PM' : 'AM'
    const h12 = h % 12 || 12
    return `${String(h12).padStart(2, '0')}:${m} ${ampm}`
  },
  formatDuration(duration) {
    if (!duration) return '—'
    if (typeof duration === 'object') {
      const h = String(duration.hours || 0).padStart(2, '0')
      const m = String(duration.minutes || 0).padStart(2, '0')
      return `${h}:${m}`
    }
    return String(duration)
  }
}

app.mount('#app')
